module.exports = __webpack_public_path__ + "img/eTaxiLogo.151c6cf4.png";